import Noty from 'noty';

function objectWithoutProperties (obj, exclude) { var target = {}; for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k]; return target; }

var defaults = {
  closeWith: ['click'],
  layout: 'topRight',
  progressBar: false,
  timeout: 3000,
  type: 'info',
};

var template = "\n  <div\n    class=\"pt-alert noty_body {{class}}\"\n    role=\"alert\"\n  >\n    <p>{{message}}</p>\n  </div>\n";

var PtNotification = {
  options: {},
  setOptions: function setOptions(opts) {
    this.options = Object.assign({}, defaults, opts);
    return this;
  },
  show: function show(text, type, opts) {
    if ( type === void 0 ) type = 'info';
    if ( opts === void 0 ) opts = {};

    var onClick = opts.onClick;
    var onClose = opts.onClose;
    var rest$1 = objectWithoutProperties( opts, ["onClick", "onClose"] );
    var rest = rest$1;
    var params = Object.assign({}, this.options, rest, {type: type, text: text});

    return new Noty(Object.assign({}, params,
      {callbacks: {
        onTemplate: function onTemplate() {
          var type = this.options.type;
          this.barDom.innerHTML = template
            .replace('{{message}}', this.options.text)
            .replace('{{class}}', ("pt-alert-" + (type === 'error' ? 'danger' : type)));
        },
        onClick: function onClick$1() {
          if (onClick) {
            onClick();
          }
        },
        onClose: function onClose$1() {
          if (onClose) {
            onClose();
          }
        },
      }})).show();
  },
  error: function error(text, opts) {
    if ( opts === void 0 ) opts = {};

    return this.show(text, 'error', opts);
  },
  info: function info(text, opts) {
    if ( opts === void 0 ) opts = {};

    return this.show(text, 'info', opts);
  },
  success: function success(text, opts) {
    if ( opts === void 0 ) opts = {};

    return this.show(text, 'success', opts);
  },
  warning: function warning(text, opts) {
    if ( opts === void 0 ) opts = {};

    return this.show(text, 'warning', opts);
  },
};

var Notification = {
  install: function install(Vue, opts) {
    var noty = PtNotification.setOptions(opts);
    Vue.prototype.$notification = noty;
  },
};

export { Notification as PtNotification };
